import React from 'react';
import styles from './footer.module.scss';
import PureImage from '../../../common/Image/PureImage';
import PureLink from '../../../common/Link/PureLink';
import { LinkModel } from '../../../../lib/types/aemDataModels';
import { WithMappedAEMProperties } from '../../../../types';
import { SCALE } from '../../../common/Image/ImageScale';

export type FooterProps = WithMappedAEMProperties<{
  logoRef?: string;
  disclaimer?: string;
  links?: LinkModel[];
  logoLink?: string;
  logoLinkDescription?: string;
}>;

export const Footer = ({
  logoRef: fileReference,
  disclaimer,
  links,
  logoLink,
  logoLinkDescription,
}: FooterProps): React.JSX.Element | null => {
  const handleOnClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.OneTrust?.ToggleInfoDisplay?.();
  };
  const imageProps = { src: fileReference ?? '', className: styles.logoImage, scale: SCALE.FOOTER_LOGO };

  return (
    <footer className={styles.section}>
      <div className={styles.container}>
        <div className={styles.logoDisclaimer}>
          <div className={styles.logo}>
            {!!fileReference && !!logoLink && (
              <PureLink href={logoLink} aria-label={logoLinkDescription} title={logoLinkDescription}>
                <PureImage {...imageProps} />
              </PureLink>
            )}
            {!!fileReference && !logoLink && <PureImage {...imageProps} />}
          </div>
          {/* eslint-disable-next-line react/no-danger */}
          <div className={styles.disclaimer} dangerouslySetInnerHTML={{ __html: disclaimer ?? '' }} />
        </div>
        <ul className={styles.linksList}>
          {links?.map(link => (
            <li key={`${link.label}-${link.link}`} className={styles.linkItem}>
              <PureLink
                href={link.link}
                className={styles.link}
                {...(link.isCookieSection ? { onClick: handleOnClick } : null)}
              >
                {link.label}
              </PureLink>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
};

export const FooterEmptyFn = (props: FooterProps) => {
  if (!props || Object.keys(props).length === 0) {
    return true;
  }

  return false;
};

export default Footer;
